export const APP_NAME = import.meta.env.VITE_APP_NAME || "MoveInReport";
export const PUBLIC_DOMAIN = import.meta.env.VITE_PUBLIC_DOMAIN || "moveinreport.com";
export const FIREBASE_PROJECT_ID =
  import.meta.env.VITE_FIREBASE_PROJECT_ID || "moveinreport-prod";
export const CANONICAL_ORIGIN = import.meta.env.VITE_CANONICAL_ORIGIN || "https://moveinreport.com";

export const CURRENT_SCHEMA_VERSION = 2;
export const MAX_ISSUES_PER_REPORT = 200;
export const MAX_AUDIO_SECONDS = 25;
export const MAX_AUDIO_MS = MAX_AUDIO_SECONDS * 1000;
export const MAX_AUDIO_BYTES = 15 * 1024 * 1024;
export const TITLE_MAX_LENGTH = 80;
export const DESCRIPTION_MAX_LENGTH = 260;
export const DRAFT_DESCRIPTION_MAX_LENGTH = 1200;
export const MAX_QUEUED_AUDIO_ITEMS_WARNING = 20;
export const MAX_QUEUED_AUDIO_ITEMS_HARD = 2000;
export const MAX_QUEUED_AUDIO_BYTES_WARNING = 100 * 1024 * 1024;
export const MAX_QUEUED_AUDIO_BYTES_HARD = 512 * 1024 * 1024;
export const PDF_LARGE_ISSUE_COUNT = 100;
export const PDF_LARGE_SIZE_WARNING_BYTES = 150 * 1024 * 1024;
export const PDF_COVER_LOGO_PATH = "/images/pdf-cover-logo-v2.png";

export const SUGGESTED_ROOMS = [
  "Kitchen",
  "Bathroom",
  "Bedroom",
  "Living Room",
  "Exterior",
  "Garage",
  "Other"
];

export const ISSUE_STATUS_LABELS = {
  not_needed: "Ready for PDF",
  needs_note: "Needs text",
  audio_saved: "Saved locally",
  queued: "Queued",
  transcribing: "Transcribing",
  needs_review: "Review note",
  approved: "Ready for PDF",
  error: "Needs attention"
} as const;

export const STORAGE_WARNING_COPY =
  "Draft saved on this device. Export a PDF when finished.";

export const QUOTA_ERROR_COPY =
  "This device is running low on browser storage. Download/export your current report or delete unused drafts before adding more photos.";
